export default __webpack_public_path__ + "static/media/naiads_desktop_bk.482a1223.png";